import { AdminLayout, useFeedback, useTranslation } from "@opendash/core";
import { Button, Col, Row, Typography } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { useState } from "react";
import { StopCard } from "../../components/StopCard";
import { StopCreateModal } from "../../components/StopCreateModal";
import UserGuide from "../../components/UI/UserGuide";
import { useMediaQuery } from "../../hooks/useBrowserWidth";
import { useStops } from "../../hooks/useStops";
import { Stop } from "../../js/parsegenerated";
import { TourId } from "../../types/TourId";

export const StopsPage = observer(() => {
  const t = useTranslation();
  const { message } = useFeedback();
  const pageRef = React.useRef<HTMLDivElement>(null);
  const [createModalVisible, setCreateModalVisible] = useState<boolean>(false);
  const [stops, reloadStops] = useStops();
  const { Title } = Typography;
  const isBelowWidth = useMediaQuery("(max-width: 576px)");

  return (
    <div ref={pageRef}>
      <AdminLayout contentPadding>
        <UserGuide.Stop />
        <Row justify="space-between" style={{ marginBottom: 20 }}>
          <Col xs={24} sm={24} md={11} lg={11} xl={11}>
            <Title level={1}>{t("gtfs:stop.title")}</Title>
          </Col>
          <Col xs={24} sm={12} md={11} lg={11} xl={11}>
            <Row justify="end">
              <Button
                id={TourId.Stop.create}
                type="primary"
                onClick={() => {
                  setCreateModalVisible(true);
                }}
                style={{
                  marginRight: 10,
                  marginBottom: 10,
                  width: isBelowWidth ? "100%" : "auto",
                }}
              >
                {t("gtfs:stop.create.button.label")}
              </Button>
            </Row>
          </Col>
        </Row>
        <p>
          Hier können Sie Ihre Haltepunkte verwalten. Diese können in Strecken
          genutzt werden, um den Fahrplan zu gestalten.
        </p>

        <Row gutter={[16, 16]}>
          <Col
            span={8}
            key={"pseudoCard"}
            style={{ display: "none" }}
            id={TourId.Stop.card}
          >
            <StopCard
              reloadStops={() => {}}
              stop={
                new Stop({
                  stop_code: "Code",
                  stop_name: "Name",
                  stop_desc: "Beschreibung",
                })
              }
            />
          </Col>
          {...stops.map((stop) => {
            return (
              <Col span={8} key={stop.id}>
                <StopCard stop={stop} reloadStops={reloadStops} />
              </Col>
            );
          })}{" "}
        </Row>

        <StopCreateModal
          open={createModalVisible}
          onOk={() => {
            setCreateModalVisible(false);
            reloadStops();
            message.success(t("gtfs:global.message.savesuccess"));
          }}
          onCancel={() => {
            setCreateModalVisible(false);
          }}
        />
      </AdminLayout>
    </div>
  );
});
